import { PartnerCalendarWidget } from "Partner/Widgets/PartnerCalendarWidget";

export function PartnerCalendarPage() {
	return <PartnerCalendarWidget />;
}
